import { render, staticRenderFns } from "./CustomTextTextarea.vue?vue&type=template&id=dae3c31e&scoped=true&"
import script from "./CustomTextTextarea.vue?vue&type=script&lang=js&"
export * from "./CustomTextTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae3c31e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
